import React, {FC, ReactNode, useEffect, useState} from "react";
import useLocalStorageState from "use-local-storage-state";
import {LOCAL_STORAGE_KEY} from "@states/local";

export const CURRENT_VERSION = "7";
const VERSION_KEY = 'version'

type VersionProps = {
    children?: ReactNode;
}

const EnsureVersion: FC<VersionProps> = React.memo(({children}) => {
    const [version, setVersion] = useVersion();
    const [wasUpgraded, setWasUpgraded] = useState(false);

    useEffect(() => {
        if (version !== CURRENT_VERSION) {
            localStorage.removeItem(VERSION_KEY);
            localStorage.removeItem(LOCAL_STORAGE_KEY);
            setVersion(CURRENT_VERSION);
            setWasUpgraded(true);
        }
    }, [version, setVersion]);

    return (
        <>
            {wasUpgraded && (
                <p className="text-center text-sm text-gray-500">
                    The bot was upgraded for you
                </p>
            )}
            {children}
        </>
    );
});

export default EnsureVersion;


export const useVersion = () => {
    const [value, setValue] = useLocalStorageState<string>(
        VERSION_KEY,
        {
            defaultValue: CURRENT_VERSION
        }
    );
    return [value, setValue] as const;
}